import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';

const AdminBusinessProfileRow = ({ businessProfile }) => {
  return (
    <tr>
      <th scope="row">
        <Link to={`/admin/businessProfiles/${businessProfile.id}`} className="link">
          {businessProfile.id}
        </Link>
      </th>
      <td>
        <div>{businessProfile.companyName}</div>
        <div>
          <small>{businessProfile.registryCode}</small>
        </div>
      </td>
      <td>{businessProfile.vatNumber}</td>
      <td>{businessProfile.invoiceInterval || '-'}</td>
      <td>
        <Link to={`/admin/users/${businessProfile.user.id}`}>
          #{businessProfile.user.id} {businessProfile.user.screenName}
        </Link>
      </td>
      <td>
        <Link to={`/admin/businessProfiles/edit/${businessProfile.id}`} className="link">
          Edit
        </Link>
        <br />
      </td>
    </tr>
  );
};

AdminBusinessProfileRow.propTypes = {
  businessProfile: PropTypes.object.isRequired,
};

export default injectIntl(AdminBusinessProfileRow);
